import {ValueObject} from '@s-ui/domain'

export class GetMessagingChannelContextUserRequest extends ValueObject {
  constructor({channelId}) {
    GetMessagingChannelContextUserRequest.validate({channelId})
    super()
    this._channelId = channelId
  }

  static create({channelId}) {
    return new GetMessagingChannelContextUserRequest({channelId})
  }

  static validate({channelId}) {
    if (!channelId || channelId === 'undefined') {
      throw new Error('channelId is required')
    }
  }

  getChannelId() {
    return this._channelId
  }

  toJSON() {
    return {
      channelId: this._channelId
    }
  }
}
